module.exports = __webpack_public_path__ + "img/screenshot2.c3240875.png";